import { ICommand, IDatasource, IDefineCommand, IQuery, key } from 'core-ts-types';
import { APGenericSlot, CourseGroupSlot, WildcardSlot } from '../../../../global/builders/ap_generic_slot_builder';
import { INVALID_ID } from '../../../../global/constants/ap_id_constants';
import { LargeCourseGroupModel } from '../models/large_course_group_model';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'hideLargeCourseGroupCommand',
    function hideLargeCourseGroupCommandDefinition(
      log: any,
      ngLargeCourseGroupModel: LargeCourseGroupModel,
      defineCommandORM: IDefineCommand
    ): ICommand {
      return defineCommandORM(
        'hideLargeCourseGroupCommand',
        function hideLargeCourseGroupCommand(deferred: ng.IDeferred<IQuery[]>): void {
          ngLargeCourseGroupModel.clear().write({
            selectedTerm: INVALID_ID,
            selectedSlot: {} as CourseGroupSlot | WildcardSlot
          });
          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/large_course_group/commands/hide_large_course_group_command.ts